export const MusicNoteIcon = ({ className }: { className: string }) => (
  <svg
    className={className}
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={className}
      d="M43.9543 0.350436L21.3083 7.27802C18.5611 8.05837 16.3395 10.917 16.3395 13.6641V37.2259C16.3395 37.2259 16.3395 37.5444 16.3395 37.5524C16.3395 37.5524 14.6992 36.4455 11.0443 36.9631C5.6774 37.7275 1.32178 41.8443 1.32178 46.168C1.32178 50.4918 5.6774 53.1354 11.0443 52.371C16.4191 51.6146 20.3527 47.6252 20.3527 43.3015C20.3527 43.3015 20.3527 24.8199 20.3527 22.9009C20.3527 20.9899 22.654 20.1617 22.654 20.1617L42.6803 13.8871C42.6803 13.8871 44.8939 13.1466 44.8939 15.193C44.8939 17.2474 44.8939 31.5644 44.8939 31.5644C44.8939 31.5644 44.8939 31.5723 44.8939 31.5803C44.8939 31.5803 42.8554 30.4018 39.2005 30.8477C33.8336 31.5007 29.478 35.5298 29.478 39.8536C29.478 44.1774 33.8336 46.9086 39.2005 46.2556C44.5674 45.6107 48.923 41.5735 48.923 37.2498V3.89386C48.923 1.15467 46.6935 -0.437875 43.9543 0.350436Z"
    />
  </svg>
);
